module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-menu/theme/lui-menuitem.global.scss
// module id = 251
// module chunks = 0 1 3